import { render } from "./alarm-type.vue?vue&type=template&id=00f617ea&ts=true"
import script from "./alarm-type.vue?vue&type=script&lang=ts"
export * from "./alarm-type.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__